import { YMaps } from '@pbe/react-yandex-maps'
import { FC, ReactNode } from 'react'

interface IYandexMapProvider {
  children: ReactNode
}

// провайдер карты, (без него нет доступа к апи яндекса)
// для просторы обернули глобально
export const YandexMapProvider: FC<IYandexMapProvider> = ({ children }) => {
  return (
    <YMaps
      query={{
        apikey: process.env.REACT_APP_YMAPS_KEY,
        lang: 'ru_RU',
      }}
    >
      {children}
    </YMaps>
  )
}
